// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// PD-0002 Mix Inteligente (Fase 4) - palco admin. Agregados so-admin do tenant (backend 403 p/ vendedor).

export const getMixRankingCategorias = async (
  cancel: any,
  estrategia: MixEstrategiaType,
  segmento: string,
  page: number
): Promise<GetMixRankingCategoriasType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/admin/ranking-categorias', {
      cancelToken: cancel.token,
      params: {
        estrategia,
        page: page - 1,
        size: 10,
        ...(segmento ? { segmento } : {}),
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getMixClientesPorCategoria = async (
  cancel: any,
  categoria: string,
  estrategia: MixEstrategiaType,
  segmento: string,
  page: number
): Promise<GetMixClientesPorCategoriaType | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/mix/admin/clientes-por-categoria',
      {
        cancelToken: cancel.token,
        params: {
          categoria,
          estrategia,
          page: page - 1,
          size: 10,
          ...(segmento ? { segmento } : {}),
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getMixCategorias = async (
  cancel: any,
  estrategia: MixEstrategiaType,
  segmento: string
): Promise<GetMixCategoriasType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/admin/categorias', {
      cancelToken: cancel.token,
      params: { estrategia, ...(segmento ? { segmento } : {}) },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// PD-0002 Fase 5 (nivel 2) - conversao do vendedor (so-admin). Sem params.
export const getMixConversaoVendedor = async (
  cancel: any
): Promise<MixConversaoType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/admin/conversao-vendedor', {
      cancelToken: cancel.token,
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getMixSimulador = async (
  cancel: any,
  estrategia: MixEstrategiaType,
  categoria: string[],
  segmento: string
): Promise<MixSimuladorType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/admin/simulador', {
      cancelToken: cancel.token,
      params: { estrategia, categoria, ...(segmento ? { segmento } : {}) },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// Ranking de clientes por potencial a agregar. vendedorId opcional (vendedor atribuido);
// omitido = todos os clientes, inclusive os sem vendedor.
//
// compraUltimosDias / predicaoProximosDias sao os filtros de atividade comercial. Omitidos =
// sem filtro no backend (ele NAO tem default): o padrao de 30 dias e desta tela, que manda o
// valor explicitamente.
//
// Os tres params numericos testam `== null`, e nao truthy: com o teste truthy o id/valor 0 seria
// descartado em silencio e o usuario veria a lista INTEIRA rotulada como filtrada. O vendedorId
// usava o idioma truthy e foi alinhado junto (o Master ja tem um usuario de id 0).
export const getMixRankingClientes = async (
  cancel: any,
  estrategia: MixEstrategiaType,
  segmento: string,
  vendedorId: number | null,
  page: number,
  compraUltimosDias: number | null,
  predicaoProximosDias: number | null
): Promise<GetMixRankingClientesType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/admin/ranking-clientes', {
      cancelToken: cancel.token,
      params: {
        estrategia,
        page: page - 1,
        size: 10,
        ...(segmento ? { segmento } : {}),
        ...(vendedorId == null ? {} : { vendedorId }),
        ...(compraUltimosDias == null ? {} : { compraUltimosDias }),
        ...(predicaoProximosDias == null ? {} : { predicaoProximosDias }),
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}
